import { render, staticRenderFns } from "./LastTemplateTable.vue?vue&type=template&id=655ba6be"
import script from "./LastTemplateTable.vue?vue&type=script&lang=js"
export * from "./LastTemplateTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports